import { Grid } from "antd";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import { withConditionalComponent } from "src/HOC";
import SSRContentWeb from "./layouts/SSRContent.web";
import SSRContentMob from "./layouts/SSRContent.mob";

const SSRContentComponent = withConditionalComponent(SSRContentWeb, SSRContentMob);

export default function SSRContent() {
  const isLargeScreen = Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];

  return <SSRContentComponent trigger={isLargeScreen} />;
}
